import Swiper from "swiper";
import { Navigation, Autoplay, FreeMode, Pagination } from "swiper/modules";

document.addEventListener("DOMContentLoaded", function () {
  const blocks = document.querySelectorAll(".gallery-slider-block");

  blocks.forEach((block) => {
    const slider = block.querySelector(".swiper");
    if (!slider) return;

    const trail = slider.querySelector(".swiper-wrapper");
    if (!trail) return;

    const prev        = block.querySelector(".swiper-button-prev");
    const next        = block.querySelector(".swiper-button-next");
    const paginationEl = block.querySelector(".swiper-pagination");

    // core/gallery renders as figure.wp-block-gallery > figure.wp-block-image (WP 6+)
    // or as figure.wp-block-gallery > ul > li (legacy). Flatten items into swiper-slides.
    if (!trail.querySelector(".swiper-slide")) {
      const gallery = trail.querySelector(".wp-block-gallery");

      if (!gallery) {
        console.warn("gallery-slider-block: no swiper slides or gallery found in", block);
        return;
      }

      // Covers nested blocks (WP 6+) and legacy list structure
      const items = Array.from(
        gallery.querySelectorAll(
          ":scope > figure.wp-block-image, .wp-block-gallery__wrapper > li"
        )
      );

      if (!items.length) {
        console.warn("gallery-slider-block: no images found in gallery", block);
        return;
      }

      items.forEach((item) => {
        const slide = document.createElement("div");
        slide.classList.add("swiper-slide", "gallery-slider__card");
        slide.appendChild(item);
        trail.appendChild(slide);
      });

      gallery.remove();
    }

    const swiper = new Swiper(slider, {
      modules      : [Navigation, Autoplay, FreeMode, Pagination],
      spaceBetween : 8,
      slidesPerView: "auto",
      centeredSlides: false,
      loop         : false,
      allowTouchMove: true,
      freeMode: {
        enabled         : true,
        sticky          : true,
        minimumVelocity : 0.05,
        momentum        : true,
        momentumRatio   : 0.5,
      },
      speed: 1200,
      navigation: {
        prevEl: prev,
        nextEl: next,
      },
      pagination: {
        el       : paginationEl,
        clickable: true,
      },
    });

    if (window.innerWidth >= 768 && "autoplay" in slider.dataset) {
      swiper.params.autoplay = {
        delay               : 2000,
        pauseOnMouseEnter   : true,
        disableOnInteraction: false,
      };
      swiper.autoplay.start();

      new IntersectionObserver(([entry]) => {
        entry.isIntersecting ? swiper.autoplay.start() : swiper.autoplay.stop();
      }).observe(block);
    }
  });
});
